import Scrollbar from 'smooth-scrollbar'

export default class SportController {

	init() {
		const options =
		{
			damping: 0.1,
			thumbMinSize: 20
		}

		const scrollbar = Scrollbar.init(document.querySelector('#my-scrollbar'), options)

		this.scrollContent = document.querySelector('.scroll-content')
		this.articlesContainer = document.querySelector('.sportArticles')
		this.articleHeight = document.querySelector('.sportArticle').offsetHeight
		this.articleWidth = document.querySelector('.sportArticle').offsetWidth
		this.articles = document.querySelectorAll('.sportArticle')
		this.container = document.querySelector('.sportNavigation')
		this.navContainer = document.querySelector('.sportNavigation__navigation')
		this.navContainerTwo = document.querySelector('.sportNavigation__navigation--2')
		this.sportWindow = document.querySelector('.sportWindow')
		this.buttons = document.querySelectorAll('.mainButtonMobile--sport .mainButton--article')
		this.buttonColorRatioX = 0
		this.buttonColorRatioY = 0
		this.count =
		{
			window: 0,
			oldX: 0,
			oldY: 0,
			offsetX: 0,
			offsetY: 0,
			magnetY: 0,
			magnetX: 0,
		}
		this.twoN = true

		this.navItem = document.querySelector('.sportNavigation__item')

		this.navItemHeight = this.navItem.offsetHeight
		this.navItemWidth = this.navItem.offsetWidth

		this.computedNavItemHeight = parseInt(window.getComputedStyle(this.navItem).marginTop) + this.navItemHeight
		this.computedNavItemWidth = parseInt(window.getComputedStyle(this.navItem).marginRight) + this.navItemWidth

		this.navItems = document.querySelectorAll('.sportNavigation__item')
		this.navFill = document.querySelectorAll('.sportNavigationFill__item')
		this.navFillColored = document.querySelectorAll('.sportNavigation__itemfill--colored')
		this.navFillContainer = document.querySelector('.sportNavigationFill')
		this.images = document.querySelectorAll('.sportNavigation__imageContainer')
		this.imagesContainer = document.querySelector('.sportNavigation__scaleContainer')

		this.navItems[0].classList.add('sportNavigation__item--fillIn')
		// this.footer = document.querySelector('.footer')
		// this.footer.classList.add('footer--undisplay')

		this.header = document.querySelector('.header')
		this.header.classList.add('header--fixed')

		this.isMobile = false
		this.delta =
		{
			y: 0,
			x: 0
		}

		if(window.innerWidth <= 900)
		{
			this.isMobile = true
		}

		// for(const image of this.images)
		// {
		// 	image.style.backgroundSize = `${this.imagesContainer.offsetWidth}px`
		// }

		this.imagesContainer.scrollTo(0, 1)
		// this.images[0].style.transform = 'translateY(1px)'

    this.listeners(scrollbar)
		// this.coverFixed()

		this.enterAnim()
	}

	enterAnim() {
		const timeline = new TimelineMax()

		timeline
      .fromTo(this.container, 1.5, {
          y: '100%'
				},
				{
					y: '0%',
					ease: Expo.easeOut
				},
				'step1'
			)
			.fromTo('.sportNavigation__imageContainer, .homeArticle__noiseImage', 1.5, {
					y: '60px'
				},
				{
					y: '0%',
					ease: Expo.easeOut
				},
				'step1+=.1'
			)
			.fromTo('.sportNavigation__scaleContainer', 1.5, {
					height: '0%',
					y: '60px'
				},
				{
					height: '100%',
					y: '0',
					ease: Expo.easeOut
				},
				'step1+=.1'
			)
			.to('.homeArticle__noiseImage', 1.5, {
					opacity: 0,
					ease: Expo.easeOut
				},
				'step1+=.4'
			)
			.fromTo('.sportNavigation__navigationO-h', 1.5, {
					y: '20%',
					opacity: 0
				},
				{
					y: '0%',
					opacity: 1,
					ease: Expo.easeOut
				},
				'step1+=1'
			)
			.fromTo('.sportArticles', 1.5, {
				y: '5%',
				opacity: 0
			},
			{
				y: '0%',
				opacity: 1,
				ease: Expo.easeOut
			},
			'step1+=1'
		)

		timeline.play()
	}

	letterByLetter(_$elem, delay) {
		const $elem = document.querySelector(_$elem)
		const letters = new SplitText($elem, { type: 'chars' })
		TweenMax.staggerFrom(letters.chars, .5, { y: '100%', ease: Power1.easeOut, delay }, .04)
	}

	listeners(scrollbar) {
		window.addEventListener('resize', () =>
		{
			this.navItemHeight = this.navItem.offsetHeight
			this.navItemWidth = this.navItem.offsetWidth

			this.computedNavItemHeight = parseInt(window.getComputedStyle(this.navItem).marginTop) + this.navItemHeight
			this.computedNavItemWidth = parseInt(window.getComputedStyle(this.navItem).marginRight) + this.navItemWidth

			this.articleHeight = document.querySelector('.sportArticle').offsetHeight
			this.articleWidth = document.querySelector('.sportArticle').offsetWidth

			if(window.innerWidth <= 900) {
				this.isMobile = true

				// Update delta.x when mobile breakpoint
				this.delta.x = this.delta.y * scrollbar.limit.x / this.delta.x
			}
			else
			{
				this.isMobile = false
			}

			// Scroll to current article when resize
			setTimeout(() => {
				window.innerWidth <= 900 ? scrollbar.scrollTo(this.articleWidth * this.count.window, 0, 300) : scrollbar.scrollTo(0, this.articleHeight * this.count.window, 300)
			}, 1000)

			// for(const image of this.images)
			// {
			// 	image.style.backgroundSize = `${this.imagesContainer.offsetWidth}px`
			// }
		})

		for(const [index, navItem] of this.navItems.entries())
		{
			navItem.addEventListener('click', () =>
			{
				if(!this.isMobile) scrollbar.scrollTo(0, this.articleHeight * index, 300)
			})
		}
		this.deltaY = 0
		// Listen scroll event
		scrollbar.addListener((event) => {
			this.deltaY = event.offset.y
			// Set delta.x or delta.y if isMobile or not
			this.isMobile ? this.delta.x = event.offset.x : this.delta.y = event.offset.y

			// Called scroll methods
			this.countWindow()
			this.navScroll()
			this.countMagnet()

			setTimeout(() =>
			{
				if((event.offset.y == this.count.oldY && !this.isMobile) || (event.offset.x == this.count.oldX && this.isMobile))
				{
					this.magnet(scrollbar)
				}

				if (!this.isMobile && event.offset.y < 50) {
					this.removeOtherOpacity()
				}

			}, 200)
		})
		this.currentPixel = this.deltaY
		this.testTitle = document.querySelector('.sportNavigation__navigation')

		this.skewEffect()
	}

	removeOtherOpacity() {
		this.images.forEach((image, index) => {
			if (index > 0) {
				image.style.opacity = 0
			}
		})
	}

	skewEffect()
	{
		const newPixel = this.deltaY

		const diff = newPixel - this.currentPixel

		const speed = diff * 0.1
		const speed2 = diff * 0.3

		// if(speed < 15 && speed > -15) this.testTitle.style.transform = `skewY(${-speed}deg)`
		if(speed < 15 && speed > -15 && !this.isMobile) this.navContainer.style.transform = `translateY(${-this.delta.y / (this.articleHeight / this.computedNavItemHeight)}px) skewY(${-speed}deg)`
		if(speed < 15 && speed > -15 && !this.isMobile) this.navContainerTwo.style.transform = `translateY(${-this.delta.y / (this.articleHeight / this.computedNavItemHeight)}px) skewY(${-speed}deg)`

		if(speed < 15 && speed > -15 && this.isMobile) this.navContainer.style.transform = `translateX(${- this.delta.x / (this.articleWidth / this.computedNavItemWidth)}px) skewY(${-speed}deg)`
		if(speed < 15 && speed > -15 && this.isMobile) this.navContainerTwo.style.transform = `translateX(${- this.delta.x / (this.articleWidth / this.computedNavItemWidth)}px) skewY(${-speed}deg)`


		// if(speed < 15 && speed > -15) this.testTitle2.style.transform = `skewY(${-speed2}deg)`
		// if(speed < 15 && speed > -15) this.testTitle3.style.transform = `skewY(${-speed2}deg)`

		this.currentPixel = newPixel

		// setTimeout(() => { this.skewEffect() }, 30)
		window.requestAnimationFrame(() => { this.skewEffect() })
	}
	navScroll()
	{
		if(!this.isMobile)
		{
			this.buttonColorRatioY = (this.delta.y - (this.articleHeight * (this.count.window - 1))) / (this.articleHeight)

			// Update article opacity
			if(this.articles[this.count.window - 1]) {
				this.articles[this.count.window - 1].style.opacity = `${1 - (this.buttonColorRatioY * 3)}`
			}
			if (this.navFillColored[this.count.window - 1]) {
				this.navFillColored[this.count.window - 1].style.opacity = `${this.buttonColorRatioY}`
			}
			if (this.navFill[this.count.window]) {
				this.navFill[this.count.window].style.opacity = `${this.buttonColorRatioY}`
			}
			if (this.images[this.count.window]) {
				this.images[this.count.window].style.opacity = `${this.buttonColorRatioY}`
			}


			// Update transformY of navigation
			// this.navContainer.style.transform = `translateY(${-this.delta.y / (this.articleHeight / this.computedNavItemHeight)}px)`
			// this.navContainerTwo.style.transform = `translateY(${-this.delta.y / (this.articleHeight / this.computedNavItemHeight)}px)`
			this.container.style.transform = `translateY(${this.delta.y}px)`

			// Update imageContainer scrollY
			this.imagesContainer.scrollTo(0, this.delta.y / (this.articleHeight / this.imagesContainer.offsetHeight))
		}
		else
		{
			this.buttonColorRatioX = (this.delta.x - (this.articleWidth * (this.count.window - 1))) / (this.articleWidth)

			this.navContainer.style.transform = `translateX(${- this.delta.x / (this.articleWidth / this.computedNavItemWidth)}px)`
			this.navContainerTwo.style.transform = `translateX(${- this.delta.x / (this.articleWidth / this.computedNavItemWidth)}px)`
			this.container.style.transform = `translateX(${this.delta.x}px)`

			if (this.buttons[this.count.window]) {
				this.buttons[this.count.window].style.opacity = `${this.buttonColorRatioX}`
			}
			if (this.navFill[this.count.window]) {
				this.navFill[this.count.window].style.opacity = `${this.buttonColorRatioX}`
			}
			if (this.navFillColored[this.count.window - 1]) {
				this.navFillColored[this.count.window - 1].style.opacity = `${this.buttonColorRatioX}`
			}
			// this.images[this.count.window - 1].style.opacity = `${this.buttonColorRatioX}`

			// Update imageContainer scrollY
			this.imagesContainer.scrollTo(this.delta.x / (this.articleWidth / this.imagesContainer.offsetWidth), 0)
		}
	}

	countWindow()
	{
		if(!this.isMobile) // If desktop
		{
			if(this.delta.y >= this.articleHeight * this.count.window + 1 && this.count.oldY < this.delta.y)
			{
				this.count.window++
			}
			else if(this.delta.y <= this.articleHeight * (this.count.window - 1)  && this.count.window >= 2 && this.count.oldY > this.delta.y)
			{
				// Set opacity 0 when leave
				if (this.buttons[this.count.window]) {
					this.buttons[this.count.window].style.opacity = `0`
				}
				if (this.navFill[this.count.window]) {
					this.navFill[this.count.window].style.opacity = `0`
				}

				this.count.window--
			}
			this.count.oldY = this.delta.y
		}
		else // If mobile
		{
			if(this.delta.x >= this.articleWidth * this.count.window + 1 && this.count.oldX < this.delta.x)
			{
				this.count.window++
			}
			else if(this.delta.x <= this.articleWidth * (this.count.window - 1)  && this.count.window >= 2 && this.count.oldX > this.delta.x)
			{
				// Set opacity 0 when leave
				if (this.buttons[this.count.window]) {
					this.buttons[this.count.window].style.opacity = `0`
				}
				if (this.navFill[this.count.window]) {
					this.navFill[this.count.window].style.opacity = `0`
				}

				this.count.window--
			}
			this.count.oldX = this.delta.x
		}
	}

	countMagnet()
	{
		if(!this.isMobile)
		{
			if(this.delta.y >= this.articleHeight * this.count.magnetY + (this.articleHeight / 2))
			{
				this.count.magnetY++
			}
			else if(this.delta.y <= (this.articleHeight) * (this.count.magnetY - 1) + (this.articleHeight / 2) && this.count.magnetY >= 1)
			{
				this.count.magnetY--
			}
		}
		else
		{
			if(this.delta.x >= this.articleWidth * this.count.magnetX + (this.articleWidth / 2))
			{
				this.count.magnetX++
			}
			else if(this.delta.x <= this.articleWidth * (this.count.magnetX - 1) + (this.articleWidth / 2) && this.count.magnetX >= 1)
			{
				this.count.magnetX--
			}
		}

	}

	magnet(scrollbar)
	{
		!this.isMobile ? scrollbar.scrollTo(0, this.articleHeight * this.count.magnetY, 100) : scrollbar.scrollTo(this.articleWidth * this.count.magnetX, 0, 200)
  }


  coverFixed() {
    const cover = () => {
      const $images = document.querySelectorAll('.sportNavigation__imageContainer')
      for (const $image of $images) {
        const url = window.getComputedStyle($image).backgroundImage.slice(5, -2)
        const image = new Image()
        image.src = url
        image.addEventListener('load', () => {
          if (image.width >= image.height && window.getComputedStyle($image).width >= window.getComputedStyle($image).height) {
            $image.style.backgroundSize = `auto ${window.getComputedStyle($image).height}`
            $image.style.backgroundPositionX = `${(image.height - image.width) / 2}px`
          }
          if (image.width >= image.height && window.getComputedStyle($image).width < window.getComputedStyle($image).height) {
            $image.style.backgroundSize = `auto ${window.getComputedStyle($image).height}`
            $image.style.backgroundPositionX = `${(image.height - image.width) / 2}px`
          }
          if (image.width < image.height && window.getComputedStyle($image).width >= window.getComputedStyle($image).height) {
            $image.style.backgroundSize = `auto ${window.getComputedStyle($image).width.slice(0,-2) * (image.height / image.width)}px`
            $image.style.backgroundPositionY = `-${(image.width - image.height) / 2}px`
          }
          if (image.width < image.height && window.getComputedStyle($image).width < window.getComputedStyle($image).height) {
            $image.style.backgroundSize = `auto ${window.getComputedStyle($image).width.slice(0,-2) * (image.height / image.width)}px`
            $image.style.backgroundPositionY = `-${(image.width - image.height) / 2}px`
          }
        })
      }
    }
    window.addEventListener('resize', () => { cover() })
    cover()
  }
}
